import { render, staticRenderFns } from "./AdminLayoutView.vue?vue&type=template&id=55996d04"
import script from "./AdminLayoutView.vue?vue&type=script&lang=ts"
export * from "./AdminLayoutView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports